import React from "react";
import { useRouteMatch, Switch, NavLink, Route, Redirect } from "react-router-dom";
import { useTranslation } from "../../context";
import Layout from "../../Layout";
// import MainTabs from '../../components/MainTabs';
import PageList from "./PageList";
import SpaceList from "./SpaceList";

import "./index.less";

export default function () {
  const lang = useTranslation();
  const { path, url } = useRouteMatch();
  return (
    <div className="joyspace-follow-wrap">
      <Layout>
        {/* <Layout.Breadcrumbs text={lang('follow.title')} /> */}
        {/* <MainTabs> */}
        {/* <NavLink to={`${url}/document`}>{lang('common.doc')}</NavLink> */}
        {/* <NavLink to={`${url}/space`}>{lang('common.space')}</NavLink> */}
        {/* </MainTabs> */}
        <Switch>
          <Route exact path={path} component={() => <Redirect to={`${path}/document`} />} />
          <Route path={`${path}/document`} component={PageList} />
          <Route path={`${path}/space`} component={SpaceList} />
          <Redirect to={`${path}/document`} />
        </Switch>
      </Layout>
    </div>
  );
}
